import React, { Component } from 'react';

class Footer extends Component {

    render() {
        return (
            <div id = 'footer'>
                <p>Heikki Heiskanen &copy; 2017 <br/> Powered by React and Firebase</p>
            </div>
        );
    }

}

export default Footer;


// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.jsx